import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'
import classnames from 'classnames'

import './index.scss'

class ProjectPreview extends Component {
  render () {
    const { heading, children, className, link, image, ratio, client, col } = this.props

    let colClass

    if (col) {
      colClass = 'col-md-' + col
    } else {
      colClass = 'col-md-8'
    }
    const previewClass = classnames('project-preview col-xs-17 ' + colClass, className)

    let imgUrl = image;
    var imageStyle = {
      backgroundImage: 'url(' + imgUrl + ')',
      paddingBottom: ratio + '%'
    }

    let imageDiv

    if (imgUrl) {
      imageDiv = (
        <div
          className="image-container"
          style={imageStyle}>
        </div>
      )
    }

    return (
      <div className={previewClass}>
        <Link to={link}>
          {imageDiv}
          <div className='card-wrapper card-title'>
            <h3>{heading}</h3>
            <h3>{client}</h3>
          </div>
          <div className='card-content'>
            {children}
          </div>
        </Link>
      </div>
    )
  }
}

ProjectPreview.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
  ratio: PropTypes.string,
  col: PropTypes.string,
  client: PropTypes.string,
}

export default ProjectPreview



// WEBPACK FOOTER //
// ./src/components/ProjectPreview/index.js